<template>
  <div id="splash-text">
    <div>Production Accounting</div>
    <div>In the Cloud</div>
  </div>
</template>

<script>
  export default {
    name: 'splashText'
  }
</script>

<style scoped>
  #splash-text {
    font-size: 24px;
    color: #324157;
    width: 100%;
  }
  #splash-text div:first-child {
    font-size: 38px;
    margin: 12px 0;
    width: 80%;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/SplashText.vue